import colors from '_containers/Theme/corporate/colors';


export default {
  arrowWrapper: {
    pathFillColor: colors.element.primary,
    pathFillColorHover: colors.element.neutralWhite,
  }
}
